import type { TFunction } from 'i18next';

import type { Uom } from '@/api/generated/model';
import { formatDecimal, type DecimalString } from '@/lib/decimal';

/** Точность учёта: кг — до грамма, шт и коробки — целые (как QUANTUM в backend/app/domain/units.py). */
export const UOM_PLACES: Record<Uom, number> = { kg: 3, pcs: 0, box: 0 };

/** «кг» / «шт» / «кор.» на языке интерфейса. */
export function uomLabel(t: TFunction, uom: Uom): string {
  return t(`uom.${uom}`);
}

/** «3 кг», «20 шт» — для текста (подтверждения, сообщения). */
export function qtyText(t: TFunction, value: DecimalString, uom: Uom): string {
  return `${formatDecimal(value, { maxPlaces: UOM_PLACES[uom] })} ${uomLabel(t, uom)}`;
}
